import { FeatureFlag } from '@common/interfaces/config/IFeatureFlags';
import { defaultFeatureFlags } from '@common/utils/dynamicConfig/dynamicConfigs';
import { trpc } from 'trpc/client';

export const useHasFeature = (feature: FeatureFlag) => {
  const query = trpc.config.getFeatureFlags.useQuery(undefined, {
    select: (data) => {
      return data[feature];
    },
  });

  return query.data ?? defaultFeatureFlags[feature];
};
